export default "__VITE_ASSET__12oPi21t__"